/* ============================================================
   NP-CAROUSEL.JS — Universal carousel for all sections
   Works on any element with [data-np-carousel]
   ============================================================ */

(function () {
  'use strict';

  class NpCarousel {
    constructor(el) {
      this.el       = el;
      this.track    = el.querySelector('.np-carousel__track');
      this.prevBtn  = el.querySelector('.np-carousel__btn--prev');
      this.nextBtn  = el.querySelector('.np-carousel__btn--next');
      this.dots     = Array.from(el.querySelectorAll('.np-carousel__dot'));
      this.progFill = el.querySelector('.np-carousel__progress-fill');
      this.autoplay = el.dataset.npAutoplay === 'true';
      this.interval = parseInt(el.dataset.npInterval || '5000', 10);
      this._timer   = null;
      this._active  = 0;

      if (!this.track) return;
      this._bind();
      this._update();
    }

    _bind() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this._scrollBy(-1); this._resetTimer(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this._scrollBy(1);  this._resetTimer(); });

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => { this._scrollToItem(i); this._resetTimer(); });
      });

      // Update dots/progress on scroll
      this.track.addEventListener('scroll', () => this._update(), { passive: true });

      // Keyboard support when focused inside carousel
      this.el.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  { this._scrollBy(-1); this._resetTimer(); }
        if (e.key === 'ArrowRight') { this._scrollBy(1);  this._resetTimer(); }
      });

      // Autoplay
      if (this.autoplay) this._startTimer();

      // Pause autoplay on hover
      this.el.addEventListener('mouseenter', () => this._clearTimer());
      this.el.addEventListener('mouseleave', () => { if (this.autoplay) this._startTimer(); });
    }

    _scrollBy(dir) {
      const itemWidth = this._itemWidth();
      this.track.scrollBy({ left: dir * itemWidth, behavior: 'smooth' });
    }

    _scrollToItem(index) {
      const itemWidth = this._itemWidth();
      this.track.scrollTo({ left: index * itemWidth, behavior: 'smooth' });
    }

    _itemWidth() {
      const firstItem = this.track.querySelector('.np-carousel__item');
      if (!firstItem) return this.track.offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap || '0', 10);
      return firstItem.offsetWidth + gap;
    }

    _currentIndex() {
      const itemWidth = this._itemWidth();
      return Math.round(this.track.scrollLeft / (itemWidth || 1));
    }

    _totalItems() {
      return this.track.querySelectorAll('.np-carousel__item').length;
    }

    _update() {
      const idx   = this._currentIndex();
      const total = this._totalItems();

      // Dots
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));

      // Progress bar
      if (this.progFill) {
        const pct = total <= 1 ? 100 : (idx / (total - 1)) * 100;
        this.progFill.style.width = pct + '%';
      }

      // Arrows
      const atStart = this.track.scrollLeft <= 4;
      const atEnd   = this.track.scrollLeft + this.track.offsetWidth >= this.track.scrollWidth - 4;
      if (this.prevBtn) this.prevBtn.classList.toggle('is-hidden', atStart);
      if (this.nextBtn) this.nextBtn.classList.toggle('is-hidden', atEnd);

      this._active = idx;
    }

    _startTimer() {
      this._clearTimer();
      this._timer = setInterval(() => {
        const atEnd = this.track.scrollLeft + this.track.offsetWidth >= this.track.scrollWidth - 4;
        if (atEnd) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this._scrollBy(1);
        }
      }, this.interval);
    }

    _clearTimer()  { clearInterval(this._timer); }
    _resetTimer()  { if (this.autoplay) { this._clearTimer(); this._startTimer(); } }
  }

  // Auto-init all carousels on the page
  function initAll() {
    document.querySelectorAll('[data-np-carousel]').forEach(el => {
      if (!el._npCarousel) {
        el._npCarousel = new NpCarousel(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify section is rendered in theme editor
  document.addEventListener('shopify:section:load', initAll);

  window.NewParadigm = window.NewParadigm || {};
  window.NewParadigm.NpCarousel = NpCarousel;
  window.NewParadigm.initCarousels = initAll;

})();
